import type { ChangeEvent } from "react";
import { useMemo, useState } from "react";

import type { FormDataRuleGroupsFE } from "@/api/graphql/formDataInjector/getSearchFormDataRuleGroups/types";

export const useFilteredRules = (
  rules: FormDataRuleGroupsFE[] | undefined = [],
) => {
  const [queryString, setQueryString] = useState("");

  const filteredRules = useMemo(() => {
    if (rules.length === 0) return [];
    const q = queryString.toLowerCase().trim();

    return q
      ? rules.filter(
          (rule) =>
            rule.name.toLowerCase().includes(q) ||
            rule.description.toLowerCase().includes(q),
        )
      : rules;
  }, [rules, queryString]);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQueryString(e.target.value);
  };

  return { queryString, filteredRules, handleSearchChange };
};
